import { State } from '@/components/atoms';
import { ProductCard, TabsContent } from '@/components/molecules';
import { useProducts, useDeleteProduct } from '@/api';
import { filterProducts } from '@/lib/helpers/filter-products';

interface OutOfStockProductsProps {
  onAddProduct: () => void;
  searchQuery: string;
  categoryId?: number;
  subcategoryId?: number;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
}

export const OutOfStockProducts = ({
  onAddProduct,
  searchQuery,
  categoryId,
  subcategoryId,
  onView,
  onEdit,
}: OutOfStockProductsProps) => {
  const { data: products } = useProducts({ categoryId, subcategoryId });
  const { mutate: remove } = useDeleteProduct();

  const outOfStockProducts = filterProducts(
    products?.filter((product) => product.quantity === 0),
    { searchQuery, categoryId, subcategoryId }
  );

  const hasActiveFilters =
    !!searchQuery.trim() || categoryId != null || subcategoryId != null;

  return (
    <TabsContent value="out-of-stock">
      {!outOfStockProducts || outOfStockProducts.length < 1 ? (
        <State
          description={
            hasActiveFilters
              ? 'No out-of-stock products match your filters'
              : "You don't have any products out of stock"
          }
          button={
            hasActiveFilters
              ? undefined
              : {
                  icon: 'Plus',
                  text: 'Add Product',
                  onClick: onAddProduct,
                }
          }
        />
      ) : (
        <div className="grid grid-cols-12 gap-2.5">
          {outOfStockProducts.map((product, index) => (
            <ProductCard
              key={product?.id || index}
              id={product?.id}
              name={product?.name}
              description={product?.shortDescription}
              price={product?.price}
              categoryName={product?.category?.name}
              subcategoryName={product?.subcategory?.name}
              quantity={product?.quantity}
              images={product?.productImages?.map((img) => img?.image?.url)}
              handleDelete={() => remove(product?.id)}
              handleView={() => onView(product.id)}
              handleEdit={() => onEdit(product.id)}
              className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
              variant="owner"
            />
          ))}
        </div>
      )}
    </TabsContent>
  );
};
